import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import QRCode from 'qrcode';
import { QrCode, RefreshCw } from 'lucide-react';
import { tr } from 'i18n';
import { SectionHeading } from 'components/Erp/Presentation';
import './DriverQrPass.scss';

type Props = { uid: string; className?: string };
type QrState = { uid: string; source: string; failed: boolean };

export default function DriverQrPass({ uid, className }: Props) {
  useTranslation();
  const [qr, setQr] = useState<QrState>({ uid: '', source: '', failed: false });
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let active = true;
    setQr({ uid, source: '', failed: false });
    QRCode.toDataURL(uid, {
      type: 'image/png',
      errorCorrectionLevel: 'Q',
      margin: 4,
      scale: 8,
      color: { dark: '#000000FF', light: '#FFFFFFFF' },
    }).then(source => {
      if (active) setQr({ uid, source, failed: false });
    }).catch(() => {
      if (active) setQr({ uid, source: '', failed: true });
    });
    return () => { active = false; };
  }, [uid, attempt]);

  const source = qr.uid === uid ? qr.source : '';
  const failed = qr.uid === uid && qr.failed;

  return <section className={`driver-qr-pass ${className || ''}`} aria-label={tr('QR-пропуск')}>
    <SectionHeading icon={QrCode} title={tr('QR-пропуск')} tone="primary" as="h3" />
    <p className="driver-qr-pass__hint">{tr('Предъявите QR-код охраннику или оператору для отметки')}</p>
    {source ? <div className="driver-qr-pass__code">
      <img src={source} alt={tr('QR-пропуск')} width={224} height={224} draggable={false} />
    </div> : <div className="driver-qr-pass__status" role={failed ? 'alert' : 'status'}>
      <p>{tr(failed ? 'Не удалось подготовить QR-код. Повторите загрузку.' : 'Подготовка QR-кода...')}</p>
      {failed && <button type="button" onClick={() => setAttempt(value => value + 1)}><RefreshCw size={16} aria-hidden="true" />{tr('Повторить загрузку')}</button>}
    </div>}
    <p className="driver-qr-pass__uid">{uid}</p>
  </section>;
}
